import { readCsrfToken, rpc } from "../api/rpc";
import type { Revision } from "../api/types";
import { fileDownload } from "../lib/csv";

/**
 * Downloading one revision as markdown. `revisions.export` is the endpoint the
 * spec names (`docs/spec/revisions.md` §4.5); it produces a file operation that
 * this edition does not have yet, so when it refuses we fall back to the body
 * `revisions.info` already carries. Either way the reader gets their file.
 */
export async function downloadRevision(revision: Revision): Promise<void> {
  const name = `${revision.title === "" ? "Untitled" : revision.title}.md`;
  const csrf = readCsrfToken();

  try {
    const response = await fetch("/api/revisions.export", {
      method: "POST",
      credentials: "include",
      headers: {
        "content-type": "application/json",
        accept: "text/markdown",
        ...(csrf === null ? {} : { "x-csrf-token": csrf }),
      },
      body: JSON.stringify({ id: revision.id }),
    });
    if (response.ok) {
      fileDownload.save(name, await response.text(), "text/markdown;charset=utf-8");
      return;
    }
  } catch {
    /* fall through to the body we already hold */
  }

  const text =
    revision.text ?? (await rpc<Revision>("revisions.info", { id: revision.id })).data.text;
  fileDownload.save(name, text ?? "", "text/markdown;charset=utf-8");
}
